import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box
} from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { formatDate } from 'src/utils/help';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const DocumentsSection = ({ doc }: { doc: any }) => {
  const isImage = doc.file_type?.startsWith('image/');
  const isPdf = doc.file_type === 'application/pdf';

  const handleView = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(doc.file_url, '_blank');
  };

  const handleDownload = async (e: React.MouseEvent) => {
    e.stopPropagation();

    try {
      const response = await fetch(doc.file_url);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = window.document.createElement('a');
      link.href = url;
      link.download = doc.file_name;
      window.document.body.appendChild(link);
      link.click();

      window.document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <Card sx={{ borderRadius: 1, boxShadow: 3, position: 'relative' }}>
      <Box
        sx={{
          height: 180,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#f5f5f5'
        }}
      >
        {isImage ? (
          <Box
            component="img"
            src={doc.file_url}
            alt={doc.file_name}
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : isPdf ? (
          <PictureAsPdfIcon sx={{ fontSize: 80, color: '#d32f2f' }} />
        ) : (
          <InsertDriveFileIcon sx={{ fontSize: 80 }} />
        )}
      </Box>

      {/* ACTIONS */}
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          display: 'flex',
          gap: 1,
          background: 'rgba(0,0,0,0.55)',
          borderRadius: 2,
          p: 0.5
        }}
      >
        <IconButton size="small" onClick={handleView} sx={{ color: '#fff' }}>
          <VisibilityIcon fontSize="small" />
        </IconButton>

        <IconButton
          size="small"
          onClick={handleDownload}
          sx={{ color: '#fff' }}
        >
          <DownloadIcon fontSize="small" />
        </IconButton>
      </Box>

      <CardContent>
        <Typography fontWeight={600} noWrap>
          {doc.file_name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Uploaded: {formatDate(doc.uploaded_at)}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default DocumentsSection;
